"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateMessage = exports.getBrowserLocale = exports.getDetectedLanguage = void 0;

var _sbLocalStorage = require("../services/sb-local-storage");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @description
 * Detects and returns the language to be used by the UI.
 *
 * @returns {string}                Language abbr. to be used.
 */
var getDetectedLanguage = function getDetectedLanguage(languages) {
  var language = (0, _sbLocalStorage.getItem)('language');

  if (!language) {
    // It wasn't saved in a local storage. Let's check the browser.
    language = getBrowserLocale();
  } // if !language, return the first in the list.


  if (!language) {
    return languages[0];
  } //  check to see if the language is supported in the list of languages, if so, return the language


  if (isLanguageSupported(languages, language)) {
    return language;
  } //  check to see if the base of the language is supported in the list of languages, if so, return the base language


  var baseLanguage = getBaseLanguage(language);

  if (isLanguageSupported(languages, baseLanguage)) {
    return baseLanguage;
  } // if all else fails, return the last language in the list.


  return languages[0];
};
/**
 * @desc
 * returns the base language from a extended language.  (e.g. en from en-US)
 * @param language
 * @returns {*|string}
 */


exports.getDetectedLanguage = getDetectedLanguage;

var getBaseLanguage = function getBaseLanguage(language) {
  return language.split('-')[0];
};
/**
 * @desc
 * returns true is the language is in the list of languages
 * @param languages
 * @param languageCode
 * @returns {boolean}
 */


var isLanguageSupported = function isLanguageSupported(languages, languageCode) {
  return languages.indexOf(languageCode) > -1;
};
/**
 * @desc
 * Detects and returns locale used in user's browser.
 *
 * Inspired by npm package browser-locale.
 *
 * @public
 * @function
 *
 * @returns {string}  * - Detected locale.
 */


var getBrowserLocale = function getBrowserLocale() {
  if (navigator.languages) {
    // Chrome does not currently set navigator.language correctly https://code.google.com/p/chromium/issues/detail?id=101138
    // but it does set the first element of navigator.languages correctly
    return navigator.languages[0];
  }

  if (navigator.userLanguage) {
    // IE only
    return navigator.userLanguage;
  } // as of this writing the latest version of firefox + safari set this correctly


  return navigator.language;
};
/**
 *
 * @param formatMessage - determines whether to translate or not - useful for multi-type warnings and errors
 * @param messageDescriptor
 * @param values
 * @returns {string}
 */


exports.getBrowserLocale = getBrowserLocale;

var translateMessage = function translateMessage(formatMessage, messageDescriptor, values) {
  if (messageDescriptor) {
    if (typeof messageDescriptor === 'string') {
      return messageDescriptor;
    }

    if (_typeof(messageDescriptor) === 'object') {
      // Translate the object only if it has an id and defaultMessage, otherwise return it. (id and defaultMessage is a reactIntl requirement)
      if (messageDescriptor.id && messageDescriptor.defaultMessage) {
        return formatMessage(messageDescriptor, values);
      }

      return messageDescriptor;
    }
  }

  return '';
};

exports.translateMessage = translateMessage;
//# sourceMappingURL=utils.js.map